const apiConfig = {
  baseURL: process.env.REACT_APP_API_BASEURL,
  timeout: 200000,
};

export default apiConfig;
